import React from 'react';

export const ActionsPanel = ({ questions, answers }) => {
    // Create a map for quick question lookup
    const questionMap = new Map(questions.map(q => [q.id, q]));

    const actionsBySection = {};

    Object.entries(answers)
        .filter(([, answer]) => answer.value === 'No')
        .forEach(([id, answer]) => {
            const question = questionMap.get(id);
            const section = question?.section || 'Unknown Section';
            if (!actionsBySection[section]) {
                actionsBySection[section] = [];
            }
            actionsBySection[section].push({
                id,
                questionNumber: question?.id || id,
                response: answer.response || '',
            });
        });

    return (
        <aside style={{
            width: '300px',
            flexShrink: 0,
            position: 'sticky',
            top: '80px',
            zIndex: 50,
            alignSelf: 'flex-start',
            padding: '10px 15px',
            background: '#fff',
            borderRadius: '8px',
            boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
            maxHeight: 'calc(100vh - 100px)',
            overflowY: 'auto',
            border: '1px solid #e0e0e0'
        }}>
            <h3 style={{
                marginTop: 0,
                marginBottom: '15px',
                fontSize: '1.1rem',
                borderBottom: '1px solid #eee',
                paddingBottom: '10px',
                color: '#d32f2f'
            }}>
                Action Items
            </h3>
            {Object.keys(actionsBySection).length > 0 ? (
                <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                    {Object.entries(actionsBySection).map(([section, actions]) => (
                        <li key={section} style={{ marginBottom: '1rem', borderBottom: '1px solid #f5f5f5', paddingBottom: '1rem' }}>
                            <div style={{ fontWeight: 'bold', fontSize: '0.9rem', marginBottom: '4px', color: '#000000' }}>
                                {section}
                            </div>
                            <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                                {actions.map(action => (
                                    <li key={action.id} style={{ marginBottom: '0.5rem' }}>
                                        {action.response && (
                                            /* Removed fontWeight: 'bold' from p tag */
                                            <p style={{ fontSize: '0.85rem', margin: 0, color: '#000000' }}>
                                                <span style={{ fontWeight: 'bold' }}>{action.questionNumber}</span> - {action.response}
                                            </p>
                                        )}
                                    </li>
                                ))}
                            </ul>
                        </li>
                    ))}
                </ul>
            ) : (
                <p style={{ color: '#000000', fontSize: '0.9rem', textAlign: 'center', marginTop: '20px' }}>
                    No actions identified.
                </p>
            )}
        </aside>
    );
};